var _desc, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeftArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "17px",
    height: "30px",
    viewBox: "0 0 17 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "np_back_1513211_000000") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page",
    stroke: "none",
    strokeWidth: 1,
    fill: "#000",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Booking-Page---1.1-Default-(No-Filters)",
    transform: "translate(-20.000000, -322.000000)",
    fill: "#292929",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(20.000000, 322.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "np_back_1513211_000000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.4321127,3.31921886 C18.2135181,1.53782167 15.3937541,-1.27995293 13.6123981,0.648135933 L0.555840001,13.5559162 C-0.18528,14.2970327 -0.18528,15.6325742 0.555840001,16.3756177 L13.6123981,29.4321153 C15.3938036,31.2135125 18.2115912,28.3937616 16.4321127,26.6124138 L4.85977089,15.0401256 L16.4321127,3.31921886 Z",
    id: "Path"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/left-arrow.cd5c78492b33b8380c97730a5f5b9b75.svg";
export { ForwardRef as ReactComponent };